export class ApprovalFollowUpReasonInfo {
    Reason?: string;
    ReasonTitle?: string;
    ReasonId?: number;

    constructor() {

    }
}